import { Component, Input } from '@angular/core';

@Component({
  selector: 'monorepo-loader-app',
  templateUrl: './loader-app.component.html',
  styleUrls: ['./loader-app.component.scss'],
})
export class LoaderAppComponent {
  @Input() isLoading = true;
}
